exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "td[data-v-21c03506],th[data-v-21c03506]{width:200px}", ""]);

// exports
